import { Calendar, Home, Menu, MessageSquare, Users } from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";
import { cn } from "@/shared/utils/cn";
import { navigationState } from "@/core/routing/navigationPolicy";
import { userAction } from "@/core/telemetry/userAction";

const destinations = [
  { id: "home", label: "Home", path: "", icon: Home },
  { id: "clients", label: "Customers", path: "/clients", icon: Users },
  { id: "conversations", label: "Messages", path: "/conversations", icon: MessageSquare },
  { id: "appointments", label: "Calendar", path: "/appointments", icon: Calendar },
  { id: "apps", label: "More", path: "/apps", icon: Menu },
] as const;

export function BottomMenu() {
  const { businessId, locationId } = useParams();
  const { pathname } = useLocation();
  const basePath = `/b/${businessId}/l/${locationId}`;
  const section = pathname.slice(basePath.length).split("/")[1] || "home";
  const active = section === "agenda" ? "home"
    : destinations.some(({ id }) => id === section) ? section : "apps";

  return (
    <nav aria-label="Main navigation" className="z-20 shrink-0 border-t border-border bg-card px-1.5 pt-2 pb-[calc(8px+env(safe-area-inset-bottom))]">
      <div className="mx-auto grid max-w-[620px] grid-cols-5 gap-0.5">
        {destinations.map(({ id, label, path, icon: Icon }) => (
          <Link
            key={id}
            to={`${basePath}${path}`}
            state={navigationState("start")}
            {...userAction(`navigation.${id}`)}
            aria-current={active === id ? "page" : undefined}
            className={cn("flex min-h-[60px] min-w-0 flex-col items-center justify-center gap-1.5 rounded-2xl text-xs transition-colors hover:bg-accent", active === id ? "bg-nav-active font-bold text-primary" : "text-muted-foreground")}
          >
            <Icon className="size-[22px]" aria-hidden="true" />
            <span>{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
